import { StripDiv, LabelInfo, ModalBoxWrap, ModalBox } from './style';
import UndoButton from './undoBtn';
import RedoButton from './redoBtn';
import { useDispatch, useSelector } from 'react-redux';
import { redoRoofToolLines, undoRoofToolLines, updateRemoveAllGutterLine } from 'store/slices/RoofToolLinesSlice';
import { AppDispatch, RootState } from 'store';

import { useEffect, useMemo, useState } from 'react';
import ConfirmationModal from 'components/Basic/Modal/Confirmation';
import { ToolCancelButton } from '../../CancelButton/cancelButton';
import AutoEdgeDetectionButton from 'components/ToolWithSlider.tsx/RoofToolOptions/AutoEdgeDetectionButton';
import { DESIGN_MODES } from '../../../../../../constants';

export default function DrawModeStrip() {
	const { selectedFacets } = useSelector((state: RootState) => state.roofToolLines.data);
	const dispatch = useDispatch<AppDispatch>();
	const [removeGutterConfirmation, setRemoveGutterConfirmation] = useState<boolean>(false);
	const { designType, mode, allGutterLines: allExistingGutterLines } = useSelector((state: RootState) => state.roofData.data);
	const tempUsermappedGutterLines = Object.values(selectedFacets).flatMap(edgedata => edgedata.newAddedGutterLines);
	const { enabled: autoDetectedEdgesEdnabled } = useSelector((state: RootState) => state.roofToolLines.autoEdgeDetection);

	const allGutterLines = useMemo(() => {
		let gutteLines: { facetId: string | null, id: string | number }[] = [];
		gutteLines = tempUsermappedGutterLines.map(gl => ({ facetId: gl.facetId, id: gl.id }));
		gutteLines = gutteLines.concat(
			allExistingGutterLines.map(gl => ({ facetId: gl.roofSegmentId, id: gl.id }))
		);
		return gutteLines;
	}, [allExistingGutterLines, tempUsermappedGutterLines]);
	const showAutoEdgeDetectionButton = designType === 'ROOF' && mode !== DESIGN_MODES.NEARMAP_NREL_MANUAL;

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (!(e.ctrlKey || e.metaKey)) return;
			const key = e.key.toLowerCase();
			if (key === 'z' && !e.shiftKey) {
				e.preventDefault();
				dispatch(undoRoofToolLines());
			} else if (key === 'y' || (key === 'z' && e.shiftKey)) {
				e.preventDefault();
				dispatch(redoRoofToolLines());
			}
		};
		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [dispatch]);

	return (
		<>
			<ModalBoxWrap className='strip-update-modalbox' >
				<ModalBox>
					<StripDiv className='strip-update'>
						<LabelInfo style={{ paddingRight: '9px' }}>
							<svg xmlns="http://www.w3.org/2000/svg" width="22" height="17.3" viewBox="0 0 47 37" fill="none">
								<path d="M44.2131 2.26758H2V34.637H44.2131C44.9378 34.637 44.5151 13.0574 44.2131 2.26758Z"
									stroke="var(--defaultIconColor)" strokeWidth="3.02972" strokeLinejoin="round" />
								<path d="M44.2095 34.637L32.3125 18.6335L44.2095 2.26758"
									stroke="var(--defaultIconColor)" strokeWidth="3.02972" strokeLinecap="round" strokeDasharray="2.21 4.42" />
								<path d="M13.9648 18.8184H32.2632" stroke="var(--defaultIconColor)"
									strokeWidth="3.02972" strokeLinecap="round" strokeDasharray="2.21 4.42" />
								<path d="M2.24755 34.637L14.1445 18.6335L2.24755 2.26758"
									stroke="var(--defaultIconColor)" strokeWidth="3.02972" strokeLinecap="round" strokeDasharray="2.21 4.42" />
							</svg>
							<label>Edit Edges</label>
						</LabelInfo>
						{showAutoEdgeDetectionButton && <AutoEdgeDetectionButton />}
						<UndoButton />
						<RedoButton />
						<ToolCancelButton id="edit-edges-cancel" className='strip-cancel'/>
					</StripDiv>
					{/* {(showAutoEdgeDetectionButton && ( autoDetectedEdgesEdnabled || showAutoDetectedEdges)) && 
					<div style={{display: 'flex', flexDirection: 'row', gap:'5px'}}>
						<Button className='remove auto-detection-btn' 
							onClick={()=>dispatch(removeAutoDetected())}>
								Remove auto detected
						</Button>
						<AutoEdgeDetectionButton type='re-run'/>
					</div>
					} */}

				</ModalBox>
			</ModalBoxWrap>

			<ConfirmationModal
				open={removeGutterConfirmation}
				message='Are you sure you want to remove all gutter lines?'
				onCancel={() => setRemoveGutterConfirmation(false)}
				onConfirm={()=>{
					dispatch(updateRemoveAllGutterLine(allGutterLines));
					setRemoveGutterConfirmation(false);
				}}

			/>
		</>
	);
}